
import {
  Breadcrumbs,
  UserProfile,
  OrderDetails,
  ProductOrderDetails,
  ProgramInfo,
  PointsHistory,
  TermsForUse,
  FavouriteEmployees,
  FavouriteTreatments,
  FavouriteProducts,
  TheConsents,
  OrderHistory,
  MembershipProgram,
  MySalons,
  JoinProgram,
  Giftcards,
  PaymentMethods,
  GiftcardDetails,
} from "./components/index";

import { UserMenu } from "../Common/CommonComponents";
export default {
  components: {
    Breadcrumbs,
    UserProfile,
    UserMenu,
    OrderDetails,
    ProductOrderDetails,
    ProgramInfo,
    PointsHistory,
    TermsForUse,
    FavouriteEmployees,
    FavouriteTreatments,
    FavouriteProducts,
    TheConsents,
    OrderHistory,
    MembershipProgram,
    MySalons,
    JoinProgram,
    Giftcards,
    PaymentMethods,
    GiftcardDetails,
  },
  data: function () {
    return {
      currentView: UserProfile,
      currentViewTitle: "Profil",
      previousViewTitle: "",
      order: null,
      program: null,
    };
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    user: {
      type: Object,
      required: true,
      default: null,
    },
    layout: {
      required: true,
      default: "chain",
      type: String,
    },
    isProfile: {
      required: false,
      default: false,
      type: Boolean,
    },
    useAxios: Boolean,
  },
  computed: {
    currentProps() {
      switch (this.currentViewTitle) {
        case "Profil":
          return { user: this.user, layout: this.layout };
        case "Mine salonger":
          return { layout: this.layout };
        case "Favorittansatte":
          return { layout: this.layout };
        case "Favorittbehandlinger":
          return { layout: this.layout };
        case "Favorittprodukter":
          return { layout: this.layout };
        case "Personvern og samtykker":
          return { user: this.user, layout: this.layout };
        case "Mine besøk og bestillinger":
          return { layout: this.layout };
        case "Ordredetaljer":
          return { layout: this.layout };
        case "ProduktOrdredetaljer":
          return { user: this.user, layout: this.layout };
        case "Fordelsprogram":
          return { layout: this.layout };
        case "Info fordelsprogram":
          return {
            programId: this.program.customerProgramId,
            layout: this.layout,
            siteId: this.program.customer.siteId,
          };
        case "Poenghistorikk":
          return {
            programId: this.program.customerProgramId,
            program: this.program,
            siteId: this.program.customer.siteId,
            layout: this.layout,
          };
        case "Vilkår for bruk":
          return {
            programId: this.program.customerProgramId,
            layout: this.layout,
            siteId: this.program.customer.siteId,
          };
        case "Bli med i fordelsprogram":
          return {
            programId: this.program.customerProgramId,
            program: this.program,
            siteId: this.program.customer.siteId,
            layout: this.layout,
          };
        case "Betalingsmetoder":
          return { user: this.user, layout: this.layout };
        case "Mine gavekort":
          return { layout: this.layout };
        case "Bruk gavekort":
          return { layout: this.layout };
      }
    },
    pages() {
      return [
        {
          title: "Mine salonger",
          icon: "fxt-salon",
          path: "mine-salonger",
          component: MySalons,
        },
        {
          title: "Favorittansatte",
          icon: "fxt-heart",
          path: "favorittansatte",
          component: FavouriteEmployees,
        },
        {
          title: "Favorittbehandlinger",
          icon: "fxt-heart",
          path: "favorittbehandlinger",
          component: FavouriteTreatments,
        },
        {
          title: "Favorittprodukter",
          icon: "fxt-heart",
          path: "favorittprodukter",
          component: FavouriteProducts,
        },
        {
          title: "Mine besøk og bestillinger",
          icon: "fxt-cart",
          path: "bestillinger",
          component: OrderHistory,
        },
        {
          title: "Mine gavekort",
          icon: "fxt-gift",
          path: "mine-gavekort",
          component: Giftcards,
        },
        {
          title: "Bruk gavekort",
          icon: "",
          path: "bruk-gavekort",
          component: GiftcardDetails,
        },
        {
          title: "Betalingsmetoder",
          icon: "fxt-credit-card-checked",
          path: "betalingsmetoder",
          component: PaymentMethods,
        },
        {
          title: "Fordelsprogram",
          icon: "",
          path: "fordelsprogram",
          component: MembershipProgram,
        },
        {
          title: "Personvern og samtykker",
          icon: "",
          path: "personvern-og-samtykker",
          component: TheConsents,
        },
        { title: "Profil", icon: "", path: "profil", component: UserProfile },
        {
          title: "Ordredetaljer",
          icon: "",
          path: "ordredetaljer",
          component: OrderDetails,
        },
        {
          title: "ProduktOrdredetaljer",
          icon: "",
          path: "ProduktOrdredetaljer",
          component: ProductOrderDetails,
        },
        {
          title: "Info fordelsprogram",
          icon: "",
          path: "info-fordelsprogram",
          component: ProgramInfo,
        },
        {
          title: "Bli med i fordelsprogram",
          icon: "",
          path: "bli-med-i-fordelsprogram",
          component: JoinProgram,
        },
        {
          title: "Poenghistorikk",
          icon: "",
          path: "poenghistorikk",
          component: PointsHistory,
        },
        {
          title: "Vilkår for bruk",
          icon: "",
          path: "vilkaar-for-bruk",
          component: TermsForUse,
        },
      ];
    },
    breadcrumbs() {
      var baseCrumbs = [
        { name: "Hjem", disabled: false },
        { name: "Mine sider", disabled: false },
      ];
      switch (this.currentViewTitle) {
        case "Ordredetaljer":
          if (this.previousViewTitle == "Poenghistorikk") {
            return baseCrumbs.concat([
              {
                name: "Fordelsprogram",
                disabled: false,
                component: MembershipProgram,
              },
              ...(this.program
                ? [
                    {
                      name: "Poenghistorikk",
                      id: this.program.customerProgramId,
                      program: this.program,
                      disabled: false,
                      component: PointsHistory,
                    },
                  ]
                : []),
              {
                name: this.order
                  ? this.formatDate(this.order.appointmentDate)
                  : "Ordre",
                disabled: true,
              },
            ]);
          } else {
            return baseCrumbs.concat([
              {
                name: "Bestillinger",
                disabled: false,
                component: OrderHistory,
              },
              {
                name: this.order
                  ? this.formatDate(this.order.appointmentDate)
                  : "Ordre",
                disabled: true,
              },
            ]);
          }

        case "ProduktOrdredetaljer":
          if (this.previousViewTitle == "Poenghistorikk") {
            return baseCrumbs.concat([
              {
                name: "Fordelsprogram",
                disabled: false,
                component: MembershipProgram,
              },
              ...(this.program
                ? [
                    {
                      name: "Poenghistorikk",
                      id: this.program.customerProgramId,
                      program: this.program,
                      disabled: false,
                      component: PointsHistory,
                    },
                  ]
                : []),
              {
                name: this.order
                  ? this.formatDate(this.order.appointmentDate)
                  : "Ordre",
                disabled: true,
              },
            ]);
          } else {
            return baseCrumbs.concat([
              {
                name: "Bestillinger",
                disabled: false,
                component: OrderHistory,
              },
              {
                name: this.order
                  ? this.order.date
                    ? this.formatDate(this.order.date)
                    : this.formatDate(this.order.createdTime)
                  : "Ordre",
                disabled: true,
              },
            ]);
          }
        case "Info fordelsprogram":
          return baseCrumbs.concat([
            {
              name: "Fordelsprogram",
              disabled: false,
              component: MembershipProgram,
            },
            {
              name: this.program ? this.program.programName : "Program",
              disabled: true,
            },
          ]);
        case "Bli med i fordelsprogram":
          return baseCrumbs.concat([
            {
              name: "Fordelsprogram",
              disabled: false,
              component: MembershipProgram,
            },
            {
              name: this.program ? this.program.programName : "Program",
              disabled: true,
            },
          ]);
        case "Poenghistorikk":
          return baseCrumbs.concat([
            { name: "Fordelsprogram", component: MembershipProgram },
            { name: this.currentViewTitle, disabled: true },
          ]);
        case "Vilkår for bruk":
          return baseCrumbs.concat([
            {
              name: "Fordelsprogram",
              disabled: false,
              component: MembershipProgram,
            },
            { name: this.currentViewTitle, disabled: true },
          ]);
        case "Bruk gavekort":
          return baseCrumbs.concat([
            { name: "Mine gavekort", component: Giftcards },
            { name: this.currentViewTitle, disabled: true },
          ]);
        default:
          return baseCrumbs.concat([
            { name: this.currentViewTitle, disabled: true },
          ]);
      }
    },
    hideNavigation() {
      return [
        "Bruk gavekort",
        "Ordredetaljer",
        "ProduktOrdredetaljer",
        "Info fordelsprogram",
        "Bli med i fordelsprogram",
        "Poenghistorikk",
        "Vilkår for bruk",
      ].includes(this.currentViewTitle);
    },
  },
  methods: {
    async setComponent(route) {
      var page = this.pages.find((x) => x.path == route.query.title);
      if (page != null) {
        this.previousViewTitle = this.currentViewTitle;
        this.currentView = page.component;
        this.currentViewTitle = page.title;
        if (route.params.order) {
          this.order = route.params.order;
        }
        if (route.params.program) {
          this.program = route.params.program;
        }
        if (this.previousViewTitle.includes('betalingsmetode')) {
          await this.$store.dispatch('fairpay/getFairPayAppointmentDetails')
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    formatDate(appointmentDate) {
      return new Date(appointmentDate).toLocaleDateString("no-NO", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  watch: {
    async $route(to) {
      await this.setComponent(to);
    },
  },
  async mounted() {
    await this.setComponent(this.$route);
  },
  beforeCreate() {
    document.getElementsByTagName("html")[0].style.overflow = "hidden";
  },
  beforeDestroy() {
    document.getElementsByTagName("html")[0].style.overflow = "auto";
  },
};
